import { DataVolume, Entity, FieldType, OptionsField, PersistenceType, ReferenceField } from 'gossamer-unified';
import { TaskDefinition } from './TaskDefinition';

export interface TaskRow {
  id: number;
  status: string;
  label: string;
  url: string;
  seq: number;
  type: string;
  parent_task_id: number | null;
  assigned_to: string;
  definition_id: number;
  institution_id: number;
  workflow_id?: number;
  outcome_id?: string;
  created_at: string;
  completed_at: string;
}

export const Task: Entity<TaskRow> = {
  id: 'Task',
  title: 'Task',
  service: 'main',
  rowLabel: (row: TaskRow) => row.label,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.task',
  },
  security: [
    { role: 'staff', action: 'read', access: 'all' },
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition: "institution_id IN ({adminInstitutionId}) OR assigned_to = '{userId}'",
    },
    { role: 'all-authed', action: 'read', access: 'conditional', condition: "assigned_to = '{userId}'" },
  ],
  defaultSort: [['id', 'DESC']],
  defaultFilters: [{ fieldId: 'id', operator: 'ct', value: '' }],
  // listRowLink: '/admin/task/display/{key}',
  dataVolume: DataVolume.Large,
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    status: {
      seq: 10,
      type: FieldType.Options,
      label: 'Status',
      listColumn: true,
      editable: false,
      options: [
        {
          id: 'PENDING',
          label: 'Pending',
        },
        {
          id: 'ACTIVE',
          label: 'Active',
        },
        {
          id: 'COMPLETED',
          label: 'Completed',
        },
        {
          id: 'SKIPPED',
          label: 'Skipped',
        },
      ],
    },
    label: {
      seq: 15,
      type: FieldType.Text,
      label: 'Label',
      mandatory: true,
      listColumn: true,
      maxLength: 255,
    },
    url: {
      seq: 20,
      type: FieldType.Text,
      label: 'URL',
      mandatory: true,
      maxLength: 255,
    },
    seq: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Sequence',
      persistence: PersistenceType.SetOnCreateOnly,
    },
    type: {
      seq: 30,
      type: FieldType.Options,
      label: 'Type',
      options: (TaskDefinition.fields.type as OptionsField).options,
      persistence: PersistenceType.SetOnCreateOnly,
    },
    parent_task_id: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Parent Task Id',
      persistence: PersistenceType.SetOnCreateOnly,
    },
    assigned_to: {
      seq: 40,
      type: FieldType.Text,
      label: 'Assigned To',
      persistence: PersistenceType.SetOnCreateOnly,
      listColumn: true,
      // refEntity: User,
    },
    definition_id: {
      seq: 45,
      type: FieldType.Reference,
      label: 'Task Definition Id',
      persistence: PersistenceType.SetOnCreateOnly,
      listColumn: true,
      refEntity: TaskDefinition,
    },
    institution_id: {
      seq: 50,
      type: FieldType.Integer,
      label: 'Institution Id',
      persistence: PersistenceType.SetOnCreateOnly,
      listColumn: true,
    },
    workflow_id: {
      seq: 55,
      type: FieldType.Text,
      label: 'Workflow',
      persistence: PersistenceType.SetOnCreateOnly,
      listColumn: true,
      // refEntity: Workflow,
    },
    outcome_id: {
      seq: 60,
      type: FieldType.Text,
      label: 'Outcome',
      persistence: PersistenceType.SetOnCreateOnly,
      listColumn: true,
      maxLength: 50,
    },
    created_at: {
      seq: 65,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    completed_at: {
      seq: 70,
      type: FieldType.Datetime,
      label: 'Completed At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};

Task.fields.parent_task_id.type = FieldType.Reference;
(Task.fields.parent_task_id as ReferenceField).refEntity = Task;
